import {ListPageLogicParams} from "./list-page-logic-params";
import {EntListingActionServerSelectionMgr} from "./ent-listing-action-server-selection-mgr";
import {CheckTable} from "./check-table";
import {createAjaxRequest, postAjaxRequest, AjaxManager} from "../../common/ajax";
import {ElementFlasher} from "../misc/element-flasher";
import {removeQueryParam, setQueryParam, stripURLHost} from "../../common/url";
import {CA_enableButton, setElementText} from "../../common/dom";

export function EntListingActionLogic(
    initialNumSelected, // the number of rows that are currently selected across all pages
    numTotal, // the total number of rows (selectable and unselectable)
    numSelectable, // the total number of selectable rows
    selectedOnPage, // an array of all row IDs that are selected on this page
    clipboardContentHash, // integer which identifies the contents of the clipboard uniquely (null of clipboard is empty)
    persistentSelectionAttr, // the session attribute which stores the currently selected ids
    autoScrollRowID,
    expandListing,
    csrfToken,
    clipboardItemCount,
    clipboardOperation
) {
    this.params = new ListPageLogicParams(); // use all defaults
    this.nTotal = numTotal;
    this.clipboardContentHash = clipboardContentHash;
    this.lastSelectedRow = null; // holds the <tr> id of the last row the user pulled up a menu on
    this.csrfToken = csrfToken;
    this.expandListing = expandListing;
    this.clipboardItemCount = clipboardItemCount;
    this.clipboardLabel = clipboardOperation === 'CUT' ? i18n.list.itemsCut : i18n.list.itemsCopied;

    if (this.params.chkAllElm) {
        this.checkTable = new CheckTable(
            this.params.chkTblElm,
            this.params.chkTblRowOffClassName,
            this.params.chkTblRowOnClassName,
            this.params.chkTblRowIDPrefix,
            this.params.chkTblRowChkIDPrefix
        );

        this.params.chkAllElm.checked = initialNumSelected === numSelectable && numSelectable > 0;

        this.checkTable.setCheckedIDs(selectedOnPage);

        this.ajaxManager = new AjaxManager();

        this.serverSelectionMgr = new EntListingActionServerSelectionMgr(
            this.checkTable,
            this.params.chkAllElm,
            initialNumSelected,
            numSelectable,
            this.ajaxManager,
            csrfToken
        );
    } else {
        this.serverSelectionMgr = null;
        this.checkTable = null;
        this.ajaxManager = null;
        this.checkTable = null;
    }

    // Automatically scroll to the clicked row, when applicable
    // (eg List page -> Click a row -> Click Properties -> Cancel).
    if (autoScrollRowID && autoScrollRowID.length > 0) {
        const rowElm = document.getElementById(autoScrollRowID);
        const tableListingHeader = document.querySelector(".table-listing-header");
        const thead = document.querySelector("thead");
        if (rowElm && tableListingHeader && thead) {
            document.documentElement.scrollTop = rowElm.offsetTop
                + tableListingHeader.scrollHeight - thead.scrollHeight;
        }
    }

    this.disableAllButtons = function () {
        CA_enableButton("list-button-remove", false);
        CA_enableButton("list-button-hide", false);
        CA_enableButton("list-button-copy", false);
        CA_enableButton("list-button-cut", false);
        CA_enableButton("list-button-add", false);
        CA_enableButton("list-button-paste", false);
    };

    this.doDelete = function () {
        // pass all parameters of this current listing to the delete dialog
        let url = this.params.deleteAction + removeQueryParam(document.location.search, "referer");
        document.location = setQueryParam(url, "psm", persistentSelectionAttr);
    };

    this.doHide = function () {
        // pass all parameters of this current listing to the hide dialog
        let url = this.params.hideAction + removeQueryParam(document.location.search, "referer");
        document.location = setQueryParam(url, "psm", persistentSelectionAttr);
    };

    this._onCopyPastePostComplete = function (textResponse) {
        let cbch = parseInt(textResponse, 10);
        // the cbch hash is negative from time to time, based on the way it
        // gets computed on the server, no need to check if cbch > 0, if its
        // a number it should be assummed to be valid ZS 5/1/18
        // if (!isNaN(cbch) && cbch > 0) {
        if (!isNaN(cbch)) {
            // no longer immediately enable the paste button on the same
            // page we have just copied from. This should only be enabled on
            // page reload ZS 5/1/18
            // enableButton("list-button-paste", true);
            this.clipboardContentHash = cbch;
        }
    };

    this.doCopy = function () {
        // invoke the current listing, (including all it's state parameters), but add a special directive parameter
        let self = this; // necessary for following anonymous function call
        postAjaxRequest(
            document.location,
            [
                "_duplicate_server_side_selection",
                "COPY",
                "_CSRFToken",
                this.csrfToken,
            ],
            function (txt) {
                self._onCopyPastePostComplete(txt);
                if (self.serverSelectionMgr) {
                    self.clipboardItemCount = self.serverSelectionMgr.nSelected;
                }
                self.clipboardLabel = i18n.list.itemsCopied;
                self.refreshCountText();
            }
        );
    };

    this.doCut = function () {
        // invoke the current listing, (including all it's state parameters), but add a special directive parameter
        let self = this; // necessary for following anonymous function call
        postAjaxRequest(
            document.location,
            ["_duplicate_server_side_selection", "CUT", "_CSRFToken", this.csrfToken],
            function (txt) {
                self._onCopyPastePostComplete(txt);
                if (self.serverSelectionMgr) {
                    self.clipboardItemCount = self.serverSelectionMgr.nSelected;
                }
                self.clipboardLabel = i18n.list.itemsCut;
                self.refreshCountText();
            }
        );
    };

    this.doPaste = function () {
        // pass all parameters of this current listing to the paste dialog
        let url =
            this.params.pasteAction +
            removeQueryParam(document.location.search, "referer");
        url = setQueryParam(url, "clipboardContentHash", this.clipboardContentHash);
        document.location = url;
    };


    this.clearSelection = function () {
        // invoke the current listing, (including all it's state parameters), but add a special directive parameter
        let self = this; // necessary for following anonymous function call
        postAjaxRequest(
            document.location,
            [
                "_select",
                "NONE",
                "_CSRFToken",
                this.csrfToken,
            ],
            function (txt) {
                self.clipboardContentHash = null;
                CA_enableButton("list-button-paste", false);
                self.refreshCountText();
            }
        );
    };

    this.refreshCountText = function () {
        let totalTxt;
        let selTxt;
        let bgColor;

        if (this.serverSelectionMgr && this.serverSelectionMgr.nSelected > 0) {
            totalTxt = this.nTotal + " - ";
            selTxt = this.serverSelectionMgr.nSelected + " " + i18n.common.selected;
            bgColor = "#bbdefb";
        } else {
            totalTxt = this.nTotal;
            selTxt = "";
            bgColor = "#ffffff";
        }

        const { totalCountElm, selectedCountElm, itemsCopiedElm } = this.params;
        if (totalCountElm)
            setElementText(totalCountElm, totalTxt);
        if (selectedCountElm)
            setElementText(selectedCountElm, selTxt);

        if (itemsCopiedElm) {
            if (this.clipboardContentHash != null) {
                itemsCopiedElm.style.display = 'block';

                const label = this.clipboardItemCount !== null
                    ? `${this.clipboardItemCount} ${this.clipboardLabel}`
                    : this.clipboardLabel;

                setElementText(itemsCopiedElm, label);
            } else {
                itemsCopiedElm.style.display = 'none';
            }
        }

        const listingHeader = document.getElementsByClassName("table-listing-header")[0];
        if (listingHeader)
            listingHeader.style.backgroundColor = bgColor;
    };

    this.onRowToggle = function (rowID, event) {
        if (!this.checkTable) {
            return;
        }

        let row = this.checkTable.getRow(rowID);
        row.setChecked(row.getChecked());

        this.serverSelectionMgr.rowToggled(row);

        // Handle shift selected checkbox - this saves the row selection to the server.
        if (event && event.shiftKey && this.lastSelectedRow) {
            let justClickedIdx = row.getIndex();
            let lastClickedIdx = this.lastSelectedRow.getIndex();

            let i = Math.min(justClickedIdx, lastClickedIdx);
            let end = Math.max(justClickedIdx, lastClickedIdx);
            for (; i <= end; i++) {
                let tr = this.checkTable.getRowByIndex(i);
                if (tr) {
                    if (tr.getChecked() !== row.getChecked()) {
                        tr.setChecked(row.getChecked());
                        this.serverSelectionMgr.rowToggled(tr);
                    }
                }
            }
        }

        let enable = this.serverSelectionMgr.nSelected > 0;
        CA_enableButton("list-button-remove", enable);
        CA_enableButton("list-button-hide", enable);
        CA_enableButton("list-button-copy", enable);
        CA_enableButton("list-button-cut", enable);

        this.refreshCountText();

        this.lastSelectedRow = row;
    };

    this.onAllToggle = function () {
        this.checkTable.checkAll(this.params.chkAllElm.checked);
        this.lastSelectedRow = null;
        this.serverSelectionMgr.allToggled();
        this.refreshCountText();

        let enable = this.serverSelectionMgr.nSelected > 0;
        CA_enableButton("list-button-remove", enable);
        CA_enableButton("list-button-hide", enable);
        CA_enableButton("list-button-copy", enable);
        CA_enableButton("list-button-cut", enable);
    };

    /** Using AJAX, update the server-side session attributes "autoScrollListID" and "autoScrollRowID"
     with the given row ID and the current listing ID.
     This call is asynchronous. */
    this.sendAutoScrollRowId = function (newRowID) {
        let req = createAjaxRequest();
        if (req) {
            let url = stripURLHost(document.location);
            url = setQueryParam(url, "EntListingAction_sendAutoScrollRowId", ""); // EntListingAction looks for this keyword
            url = setQueryParam(url, "autoScrollRowID", newRowID);
            url = setQueryParam(url, "returning", ""); // don't record smart redirection info

            req.open("GET", url);
            req.send(null);
        }
    };

    this.refreshCountText();

    if (this.serverSelectionMgr && this.serverSelectionMgr.nSelected > 0) {
        if (this.params.flashElm) {
            // flash the element
            const elementFlasher = new ElementFlasher(
                this.params.flashElm,
                3,
                this.params.flashOffClassName,
                this.params.flashOnClassName,
                250
            );
            elementFlasher.start();
        }

        CA_enableButton("list-button-remove", true);
        CA_enableButton("list-button-hide", true);
        CA_enableButton("list-button-copy", true);
        CA_enableButton("list-button-cut", true);
    }

    if (this.clipboardContentHash != null)
        CA_enableButton("list-button-paste", true);

    this.expandTable = function (expand, updateServer) {
        if (typeof expand === 'string') {
            expand = parseInt(expand);
        }

        let container = document.getElementsByClassName("container");
        if (container && container.length > 0) {
            if (expand) {
                container[0].className += " fullscreen";
                CA_enableButton("list-button-expand", false);
            } else {
                container[0].className = "body container";
                CA_enableButton("list-button-expand", true);
            }
        }

        this.expandListing = expand ? 1 : 0;

        if (updateServer) {
            let req = createAjaxRequest();
            if (req) {
                const { contextPath } = GlobalEnt;
                let url = stripURLHost(contextPath + "/UpdateListingState.act");
                url = setQueryParam(url, "listingState", this.expandListing);
                req.open("POST", url);
                req.setRequestHeader('_CSRFToken', this.csrfToken);
                req.send(null);
            }
        }
    };

    let expandBtn = document.getElementById("list-button-expand");
    let expandOffBtn = document.getElementById("list-button-expand-off");
    if (expandBtn && expandOffBtn) {
        expandBtn.addEventListener(
            "click",
            this.expandTable.bind(this, true, true)
        );
        expandOffBtn.addEventListener(
            "click",
            this.expandTable.bind(this, false, true)
        );
    }

    this.shouldExpandOnPageLoad = function() {
        // For cases where many UDFs are being appended to the table, automatically expand the table
        // width on page load.
        const listSortColumns = document.querySelectorAll('.listSortCol');
        if (listSortColumns && listSortColumns.length > 10) {
            return true;
        }

        let container = document.getElementsByClassName("container");
        if (container && container.length > 0 && container[0].classList.contains('fullscreen')) {
            return true;
        }

        return this.expandListing;
    }

    this.hasSelectedCheckboxes = function() {
        return this.serverSelectionMgr.nSelected > 0;
    }

    this.expandTable(this.shouldExpandOnPageLoad(), false);
    CA_enableButton("list-button-expand", this.expandListing == 0);
}